// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__lVdio"};